/**
 * LIB lane — Process Library lineage / drift API helpers.
 *
 * Backend: djangoapp/urls_lib.py
 *   GET  /library/usage-summary/     per-block usage + drift counts
 *   GET  /library/impact/            which recipes came from a block, which drifted
 *   GET  /library/lineage/process/   one recipe process: linked? in sync? what differs
 */
import { get_api_function } from '@/utils/api';

/** Verdicts the backend returns, with the colour/label the UI shows for each. */
export const VERDICTS = {
  IN_SYNC: { label: 'In sync', color: 'green' },
  RECIPE_DRIFTED: { label: 'Drifted', color: 'orange' },
  LIBRARY_AHEAD: { label: 'Library ahead', color: 'blue' },
  BOTH_CHANGED: { label: 'Both changed', color: 'red' },
  NOT_LINKED: { label: 'Not linked', color: 'default' },
};

export const verdictMeta = (verdict) => VERDICTS[verdict] || { label: verdict || '—', color: 'default' };

const unwrap = (res) => (res?.data?.status === 'success' ? res.data.data : null);

/** { [libraryProcessId]: { usage_count, drifted_count, in_sync_count } } */
export const fetchUsageSummary = (ids, cb) =>
  get_api_function('/library/usage-summary/', (res) => cb(unwrap(res) || {}), ids?.length ? { ids: ids.join(',') } : {});

/** Impact list for one library block. */
export const fetchLibraryImpact = (libraryProcessId, cb, { diff = false } = {}) =>
  get_api_function('/library/impact/', (res) => cb(unwrap(res)), {
    library_process_id: libraryProcessId,
    diff: diff ? 1 : 0,
  });

/** Lineage + drift for one recipe process. */
export const fetchProcessLineage = (processId, cb, { diff = true } = {}) =>
  get_api_function('/library/lineage/process/', (res) => cb(unwrap(res)), {
    process_id: processId,
    diff: diff ? 1 : 0,
  });
